import React, { Component } from "react";
import { Form, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { get } from "lodash";
import { dayAgo, formatNumber } from "../../../helper";
import SelectProjectTile from "./SelectProjectTile";

export class SelectProjectSingle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOtherPPList: false
    };
  }

  selectionHandler = () => {
    const {
      idx,
      selectionHandler,
      fromCreateAgendaPage,
      deleteHandler
    } = this.props;
    //console.log("hello", idx, fromCreateAgendaPage, selectionHandler);
    selectionHandler(idx);
    //fromCreateAgendaPage ? deleteHandler(idx) : selectionHandler(idx);
  };

  toggleOtherPPList = () => {
    this.setState({
      showOtherPPList: !this.state.showOtherPPList
    });
  };

  render() {
    const { ProjectSelected, project, idx } = this.props;
    // console.log(project, this.props.projectSelected);
    //const selectedProp = projectSelected ? projectSelected : project.isSelected;
    const selectedProp = project.selectedInAgenda
      ? project.selectedInAgenda
      : project.isSelected;
    const { showOtherPPList } = this.state;
    let content;
    if (ProjectSelected === "delete") {
      content = (
        <div
          className="delete-issue"
          title="Delete"
          onClick={this.selectionHandler}
        />
      );
    } else if (ProjectSelected === "checkbox") {
      content = (
        <Form.Group controlId={`checkbox-${this.props.idx}`}>
          <Form.Check
            className={`form-checkbox ${selectedProp ? "checked" : ""} ${
              project.selectedInAgenda ? "disabled" : ""
            }`}
            //disabled={this.props.projectSelected}
            //checked={this.props.projectSelected}
          >
            <Form.Check.Input
              type="checkbox"
              name="select-issue"
              value={selectedProp}
            />
            <Form.Check.Label onClick={this.selectionHandler} />
          </Form.Check>
        </Form.Group>
      );
    } else {
      content = "";
    }

    const createdBy =
      project && project.projectPPList && project.projectPPList.length
        ? project.projectPPList[0]
        : null;
    const projectPPList =
      project && project.projectPPList && project.projectPPList.length
        ? project.projectPPList
        : [];
    const projectCost = formatNumber(
      get(project, "revisedCost", 0) || get(project, "cost", "0")
    );

    return (
      <React.Fragment>
        <div className="select-issue-wrapper select-project-wrapper agenda-issue-wrapper">
          <Form className="select-issue-form select-project-form">
            {content}
          </Form>
          <div className="issue-container">
            <SelectProjectTile project={project} key={idx} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default SelectProjectSingle;
